import request from '@/utils/request';

// 热门搜索
export const searchModel = ({like, category}) => {
    return request.post('/search/page', {
        like,
        category
    })
}
